// Evaluate before telemetry. The capability lives only in this page's memory.
export const isDatabookRetryPage = window.location.pathname === "/databook/retry";
let capability: string | null = null;
if (isDatabookRetryPage) {
  capability = new URLSearchParams(window.location.hash.slice(1)).get("token");
  window.history.replaceState(window.history.state, "", window.location.pathname);
  const referrer = document.createElement("meta");
  referrer.name = "referrer";
  referrer.content = "no-referrer";
  document.head.appendChild(referrer);
}

export type EmailRetryResult = { status: "accepted" | "scheduled" | "already_accepted"; available_at: string | null };
let request: Promise<EmailRetryResult> | null = null;

export class RetryLinkUnavailable extends Error {}

export function redeemDatabookRetry(): Promise<EmailRetryResult> {
  if (request) return request;
  if (!capability) return Promise.reject(new RetryLinkUnavailable());
  request = fetch(`${import.meta.env.VITE_API_BASE ?? ""}/api/databook-retry/consume`, {
    method: "POST",
    credentials: "omit",
    cache: "no-store",
    referrerPolicy: "no-referrer",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token: capability }),
  }).then(async (response) => {
    if (response.status === 409 || response.status === 410) {
      capability = null;
      throw new RetryLinkUnavailable();
    }
    if (!response.ok) throw new Error("Could not connect");
    const result: EmailRetryResult = await response.json();
    capability = null;
    return result;
  }).catch((error: unknown) => {
    request = null;
    throw error;
  });
  return request;
}
